import {NgModule}                              from '@angular/core';
import {CommonModule}                          from '@angular/common';
import {ApEditFieldComponent}                  from './ap-edit-field.component';
import {FormsModule, ReactiveFormsModule}      from '@angular/forms';
import {DatePickerModule}                      from '@progress/kendo-angular-dateinputs';
import {TabStripModule}                        from '@progress/kendo-angular-layout';
import {ApTranslationModule}                   from '../../translation/ap-translation.module';
import {ApCoreModule}                          from '../../ap-core/ap-core.module';
import {ComboBoxModule}                        from '@progress/kendo-angular-dropdowns';
import {ButtonModule}                          from '@progress/kendo-angular-buttons';
import {ApResponsiveTextModule}                from '../../ap-responsive-text/ap-responsive-text.module';
import {ApDynformsModule}                      from '../../ap-dynforms/ap-dynforms.module';
import {ApDynComponentModule}                  from '../../ap-dyncomponent/ap-dyncomponent.module';
import {ApUtilsModule}                         from '../../ap-utils';
import {
  ApParameterEntryComponentsModule
}                                              from '../ap-parameter-entry-components/ap-parameter-entry-components.module';
import {ApMergeFieldComponent}                 from './ap-merge-field.component';
import {ApSplitFieldComponent}                 from './ap-split-field.component';
import {ApMonitoringFieldCreateEntryComponent} from './ap-monitoring-field-create-entry.component';
import {ApMonitoringDetailEntryComponent}      from './ap-monitoring-detail-entry.component';
import {ApSingleClickDirective}                from '../../ap-utils/directives/ap-single-click.directive';
import {ApMonitoringFieldEditEntryComponent}   from './ap-monitoring-field-edit-entry.component';

const COMPONENTS = [
  ApEditFieldComponent,
  ApMergeFieldComponent,
  ApSplitFieldComponent,
  ApMonitoringFieldCreateEntryComponent,
  ApMonitoringFieldEditEntryComponent,
  ApMonitoringDetailEntryComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    FormsModule,
    DatePickerModule,
    TabStripModule,
    ReactiveFormsModule,
    ApTranslationModule,
    ApCoreModule,
    ComboBoxModule,
    ButtonModule,
    ApResponsiveTextModule,
    ApDynformsModule,
    ApDynComponentModule,
    ApUtilsModule,
    ApParameterEntryComponentsModule,
    ApSingleClickDirective,
  ],
  exports: COMPONENTS
})
export class ApFieldManagementEntryComponentsModule {
}
